import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import InputMask from "react-input-mask";

export default function SSN({ id, state, onChange }) {
  return (
    <div>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Social Security #</strong>
            <br />
            The name must match exactly as on file with the IRS and SSA. If this information submitted here does not
            match the IRS records, this will cause delays in the processing of your EIN Application.
            <br />
            <br />
            Social Security Number (SSN) is a permanently assigned nine-digit number issued by the Social Security
            Administration to identify an individual income tax account.
            <br />
            <br />
            An Individual Taxpayer Identification Number (ITIN) is a tax processing number. The IRS issues ITINs to
            individuals who are required to have a U.S. Taxpayer Identification Number but who do not have, and are not
            eligible to obtain, an SSN.
            <strong>If you have an ITIN, unfortunately you cannot obtain an EIN ONLINE.</strong>
          </Tooltip>
        }
      >
        <Form.Group controlId={id + "SSN"}>
          <Form.Label>
            Social Security Number{" "}
            <OverlayTrigger
              placement="auto"
              delay={{ show: 250, hide: 400 }}
              overlay={
                <Tooltip id="overlay-example">
                  <strong>Why do we need this?</strong>
                  <br />
                  Your valid Social Security Number is needed by the IRS to obtain an EIN. Rest assured, all Social
                  Security Numbers are stored in a fully protected fashion.
                </Tooltip>
              }
            >
              <span className="question" />
            </OverlayTrigger>
          </Form.Label>
          <InputMask mask="999-99-9999" maskChar={null} value={state[id + "SSN"]} onChange={onChange}>
            {(inputProps) => (
              <Form.Control
                required
                data-hj-allow
                type="text"
                placeholder="123-45-6789"
                pattern=".{11,}"
                maxLength="11"
                value={state[id + "SSN"]}
              />
            )}
          </InputMask>
          <Form.Control.Feedback type="invalid">
            Please provide a valid Social Security Number Ex: 123-45-6789
          </Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
    </div>
  );
}
